import { useState, useEffect } from 'react';
import { domain, env, wms_uploads_bucket } from '../config';
import qs from 'query-string';
import { showMessage } from '../Utils/message';
import moment from 'moment';
import Hashids from 'hashids';

const hashids = new Hashids('my-app-secret', 6); // salt + min length

export const encodeId = (id) => hashids.encode(id); // "NkK9"
export const decodeId = (id) => hashids.decode(id)[0]; // 12345


const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  return width;
};
export default useWindowWidth;

export const formatCurrency = (amount, locale = "en-GB", currency = "GBP") => {
  let value =
    typeof amount === "number"
      ? amount
      : Number(amount?.replace(/[^\d.-]/g, ""));
  value = isNaN(value) ? 0 : value;
  const roundedValue = value.toFixed(2);
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(roundedValue);
};

export function getNewFileName(oldFileName) {
  const extension = oldFileName?.slice(oldFileName?.lastIndexOf('.'));
  const baseName = oldFileName?.slice(0, oldFileName?.lastIndexOf('.'));
  const randomString = Math.random().toString(36).substring(2, 12);
  return `${baseName}-${randomString}${extension}`;
}

export function extractOriginalFileName(modifiedFileName) {
  const extensionIndex = modifiedFileName?.lastIndexOf('.');
  const extension = modifiedFileName?.slice(extensionIndex);
  const randomStringPattern = /-\w{10}(?=\.\w+$)/;
  const baseName = modifiedFileName?.replace(randomStringPattern, '');
  return baseName;
}

// export const handleSubmitImage = (e, setFiles, setCurrentItemFiles) => {
//   e.preventDefault();
//   let acceptedFiles = e.target.files;

//   for (let file of acceptedFiles) {
//     const newFileName = getNewFileName(file.name)
//     setFiles((prevFiles) => [
//       ...prevFiles,
//       {
//         name: newFileName,
//         display_name: newFileName,
//         file: file,
//         ContentType: file.type,
//       },
//     ]);
//     setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
//   }
// };


export const handleSubmitImage = (e, setFiles, setCurrentItemFiles, replace = false) => {
  e.preventDefault();
  const acceptedFiles = e.target.files;

  if (!acceptedFiles?.length) return;

  const newFiles = [];
  const newFileNames = [];

  for (let file of acceptedFiles) {
    const newFileName = getNewFileName(file.name);
    newFiles.push({
      name: newFileName,
      display_name: newFileName,
      file,
      ContentType: file.type,
    });
    newFileNames.push(newFileName);
  }

  // 🧠 Replace mode (for profile)
  if (replace) {
    setFiles(newFiles);
    setCurrentItemFiles(newFileNames);
  } 
  // 📦 Append mode (for multiple uploads)
  else {
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    setCurrentItemFiles((prevFiles) => [...prevFiles, ...newFileNames]);
  }
};

export const handleSubmitSingleImage = (e, setFile, setCurrentItemFile) => {
  e.preventDefault();
  const file = e.target.files?.[0];

  if (!file) return;

  const newFileName = getNewFileName(file.name);

  const newFile = {
    name: newFileName,
    display_name: newFileName,
    file,
    ContentType: file.type,
  };

  setFile(newFile);
  setCurrentItemFile(newFileName);
};

export const handleDeleteFile = (fileName, files, currentItemFiles, setFiles, setCurrentItemFiles) => {
  const updatedFiles = files?.filter((file) => file.name !== fileName);
  setFiles(updatedFiles);
  setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
};

export const handleDeleteCurrentFile = (itemToDelete, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles ) => {
  setCurrentItemFiles(
    currentItemFiles.filter((item) => item !== itemToDelete)
  );
  if (!deletedFiles.includes(itemToDelete)) {
    setDeletedFiles((prevDeletedFiles) => [
      ...prevDeletedFiles,
      itemToDelete,
    ]);
  }
};

export const getUploadUrl = async (file, folder , recordID) => {
  const params = {
    bucket: wms_uploads_bucket,
    ContentType: file.file.type,
    Key: env + "/" + folder + "/" + recordID + "/" + file.name,
  };
  const response = await fetch(
    `${domain}/generate-put-url?${qs.stringify(params)}`,
    {
      headers: {
        "Content-Type": params.ContentType,
      },
    }
  );
  return response.json();
};

export const uploadFileToS3 = async (uploadUrl, file, contentType) => {
  const response = await fetch(uploadUrl.putURL, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": contentType,
    },
  });
  if (response.status !== 200) {
    console.log('response', response);
    showMessage("error", "File upload failed.");
    throw new Error("File upload failed.");
  }
};


export const formatBatchCode = (documentNumber, date, itemCode) => {
  const DateFormat = moment(date).format('DD-MM-YYYY');
  const cleanedDoc = documentNumber.replace(/^PO/i, ''); 
  const formattedDate = date.replaceAll('-', ''); 
  return `${cleanedDoc}_${formattedDate}_${itemCode}`;
}

